import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';

interface CollaboratorLinkProps {
  collaboratorId: string;
  className?: string;
  title?: string;
  children: ReactNode;
}

/** Rend ses enfants cliquables vers la page profil public d'un collaborateur. */
export function CollaboratorLink({ collaboratorId, className, title, children }: CollaboratorLinkProps) {
  return (
    <Link
      to={`/equipe/${collaboratorId}`}
      title={title}
      onClick={(e) => e.stopPropagation()}
      className={cn('hover:opacity-80 transition-opacity cursor-pointer', className)}
    >
      {children}
    </Link>
  );
}
